import { HeaderNavigationModel, LinkModel } from '@/types';
import { Link } from '../../';
import XLight from '@/assets/xLight.svg';
import { useTranslations } from 'next-intl';
import SearchTermInput from '@/components/search/SearchTermInput';
import { useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import AutocompleteContent from '@/components/search/AutocompleteContent';
import classNames from 'classnames';
import { removeLinkQueryParams } from '@/utils';

type MobileNavAppMenuModel = {
  focusSearchInput: boolean;
  links: HeaderNavigationModel[];
  iconLinks: { icon: React.ReactNode; link: LinkModel }[];
  setActiveMenu: (menu: HeaderNavigationModel) => void;
  closeNav: () => void;
};

const MobileNavAppMenu = ({ links, iconLinks, focusSearchInput, setActiveMenu, closeNav }: MobileNavAppMenuModel) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchActive, setSearchActive] = useState(false);

  const router = useRouter();
  const t = useTranslations();

  const onSubmit = () => {
    closeNav();
    const query = {
      searchTerm,
    };
    const url = new URL(window.location.href);
    url.pathname = '/search';
    url.search = new URLSearchParams(query).toString();
    router.push(url);
  };

  const currentPath = useMemo(() => {
    return removeLinkQueryParams(router.asPath);
  }, [router.asPath]);

  return (
    <>
      <div className="container flex h-14 shrink-0 items-center justify-between pl-7">
        <SearchTermInput
          placeholder={t('search.$searchSomethingPlaceholder')}
          autofocus={focusSearchInput}
          hideClearBtn
          onSubmit={onSubmit}
          onChange={(value) => setSearchTerm(value)}
          onFocus={() => setSearchActive(true)}
          onBlur={() => {
            setTimeout(() => {
              setSearchActive(false);
            }, 200);
          }}
        />

        <button className="flex h-8 w-8 items-center justify-center rounded-full" onClick={closeNav}>
          <XLight className="h-7 w-7" />
        </button>
      </div>

      {/* SCROLLABLE MENU */}
      <div className="container flex-1 overflow-auto px-4">
        {!searchActive ? (
          <div className="flex h-full flex-col gap-5">
            <div className="flex flex-col">
              {links.map((link, index) => {
                const className = classNames(
                  'w-full py-4.5 text-center text-lg font-bold flex',
                  currentPath === link.props.link?.href && 'underline',
                );

                return link.props.link ? (
                  <Link link={link.props.link} key={index} className={className}>
                    {link.props.label}
                  </Link>
                ) : (
                  <div key={index} className={className} onClick={() => setActiveMenu(link)}>
                    {link.props.label}
                  </div>
                );
              })}
              <div className="my-3 h-px w-1/3 bg-black/10" />

              {iconLinks.map((iconLink, index) =>
                iconLink.link ? (
                  <Link link={iconLink.link} key={index} className="flex w-full py-4.5 text-center text-lg font-bold" />
                ) : null,
              )}

              <div className="my-3 h-px w-1/3 bg-black/10" />
            </div>
          </div>
        ) : (
          <AutocompleteContent searchTerm={searchTerm} />
        )}
      </div>
    </>
  );
};

export default MobileNavAppMenu;
